/**
 * Orders batch select options so batches with stock come first.
 *
 * The batch selects used to list "non batch" first and pre-select the first
 * option regardless of stock, so an empty batch (often the non-batch row) was
 * what the user got on order lines.
 *
 * Each option carries `available` (the batch's qtyNumber in the chosen
 * warehouse). With `hideEmpty`, options without stock are dropped, except
 * `keepId` so an order line already on an empty batch still shows its value.
 * If no option has stock, nothing is hidden, so the line can still be confirmed
 * the way it could before.
 */
export function sortBatchOptions(options, { hideEmpty = false, keepId = null } = {}) {
  const hasStock = option => Number(option.available) > 0;
  const keep = option => keepId !== null && keepId !== undefined && keepId !== ''
    && option.id.toString() === keepId.toString();

  const real = options.filter(option => option && option.id !== undefined);
  const withStock = real.filter(hasStock);
  const hide = hideEmpty && withStock.length > 0;
  const empty = real.filter(option => !hasStock(option) && (!hide || keep(option)));

  return withStock.concat(empty);
}

/**
 * The option to pre-select: the first one with stock, else the first one.
 */
export function defaultBatchId(options) {
  const option = options.find(o => Number(o.available) > 0) || options[0];
  return option ? option.id.toString() : '';
}

export default { sortBatchOptions, defaultBatchId };



// WEBPACK FOOTER //
// ./src/app/utils/batchOptions.js